(() => {
  if (customElements.get('brano-coupon')) return;

  class BranoCoupon extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-coupon-copy]');
      this.status = this.querySelector('[data-coupon-status]');
      this.generation = (this.generation || 0) + 1;
      this.busy = false;
      this.reset();
      this.onClick = () => this.copy();
      this.button?.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.generation += 1;
      clearTimeout(this.resetTimer);
      this.button?.removeEventListener('click', this.onClick);
    }

    reset() {
      this.button?.removeAttribute('data-copied');
      if (this.status) {
        this.status.textContent = '';
        this.status.removeAttribute('data-error');
      }
    }

    fallbackCopy(text) {
      const previousFocus = document.activeElement;
      const field = document.createElement('textarea');
      field.value = text;
      field.readOnly = true;
      field.style.cssText = 'position:fixed;inset:0;opacity:0;pointer-events:none;font-size:16px;';
      document.body.appendChild(field);
      let copied = false;
      try {
        field.focus();
        field.select();
        field.setSelectionRange(0, field.value.length);
        copied = document.execCommand('copy');
      } catch {
        copied = false;
      } finally {
        field.remove();
        if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
      }
      return copied;
    }

    async copy() {
      if (this.busy || !this.button) return;
      this.busy = true;
      const generation = this.generation;
      const code = this.button.dataset.code;
      let copied = false;
      clearTimeout(this.resetTimer);
      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(code);
          copied = true;
        }
      } catch {
        copied = false;
      }
      if (!this.isConnected || generation !== this.generation) return;
      if (!copied) copied = this.fallbackCopy(code);
      this.busy = false;
      if (copied) {
        this.button.setAttribute('data-copied', '');
        this.status.removeAttribute('data-error');
        this.status.textContent = 'Code copied. Apply it at checkout.';
        this.resetTimer = setTimeout(() => {
          if (this.isConnected && generation === this.generation) this.reset();
        }, 2500);
      } else {
        this.reset();
        this.status.setAttribute('data-error', '');
        this.status.textContent = 'Copy unavailable. Please select and copy the code manually.';
        const codeText = this.querySelector('[data-coupon-code]');
        if (codeText) {
          const range = document.createRange();
          range.selectNodeContents(codeText);
          const selection = window.getSelection();
          selection?.removeAllRanges();
          selection?.addRange(range);
        }
      }
    }
  }

  customElements.define('brano-coupon', BranoCoupon);
})();
